/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Emptystate_Closedtitle3Inputs */

const en_coinvestments_prospects_emptystate_closedtitle3 = /** @type {(inputs: Coinvestments_Prospects_Emptystate_Closedtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prospects were added`)
};

/**
* | output |
* | --- |
* | "No prospects were added" |
*
* @param {Coinvestments_Prospects_Emptystate_Closedtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_emptystate_closedtitle3 = /** @type {((inputs?: Coinvestments_Prospects_Emptystate_Closedtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Emptystate_Closedtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_emptystate_closedtitle3(inputs)
});
export { coinvestments_prospects_emptystate_closedtitle3 as "coInvestments_prospects_emptyState_closedTitle" }